export const commande_CREATE_RESET = "commande_CREATE_RESET";
export const commande_CREATE_SET_CREATED = "commande_CREATE_SET_CREATED";
export const commande_CREATE_SET_ERROR = "commande_CREATE_SET_ERROR";
export const commande_CREATE_SET_VIOLATIONS = "commande_CREATE_SET_VIOLATIONS";
export const commande_CREATE_TOGGLE_LOADING = "commande_CREATE_TOGGLE_LOADING";
